export default {
  data() {
    return {
      loginType: 'second',
      rememberMe: false,
      form: {
        username: '',
        password: '',
        captcha: '',
        phone: '',
        vcode: '',
        template: 1
      },
      rules2: {
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        vcode: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          }
        ],
        captcha: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ]
      },
      rules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ],
        captcha: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ]
      },
      vcodeUrl: SZH.assets.api + '/Authen/SendVerifyCode',
      loginUrl: SZH.assets.api + '/Authen/Login',
      phoneloginUrl: SZH.assets.api + '/Authen/LoginForPhone',
      logoutUrl: SZH.assets.api + '/Authen/Logout',
      captchaUrl: SZH.assets.api + '/Authen/Captcha',
      GetProgramQuality: SZH.assets.api + '/Market/GetProgramQuality',
      captchaUrlTails: 'feelingscoder',
      sendOk: false,
      loading: false,
      sendVCodeTime: 0
    }
  },
  created(){
    localStorage.removeItem('ms_accountname');
  },
  mounted() {
    var ms_customname = localStorage.getItem('ms_customname');
    var ms_token_expires = localStorage.getItem('ms_token_expires');
    if(ms_customname || ms_token_expires) {
      var self = this;
      self.$http.post(self.logoutUrl, {
      }).then(result => {
        localStorage.removeItem('ms_customname');
        localStorage.removeItem('ms_accountname');
        localStorage.removeItem('ms_customno');
        localStorage.removeItem('ms_token');
        localStorage.removeItem('ms_token_expires');
      }, () => { });
    }

    this.refreshCaptcha();

    var x = localStorage.getItem("sendvcodetime");
    if(x != null) {
      var i = parseInt(x);
      if(i > 0)
      {
        this.sendVCodeTime = i;
        var me = this;
        let index = setInterval(() => {
          if(me.sendVCodeTime > 0) {
            localStorage.setItem("sendvcodetime", --me.sendVCodeTime);
          }
          else {
            clearInterval(index)
            localStorage.removeItem("sendvcodetime")
          }
        }, 1000);
      }
    }
  },
  methods: {
    turnTo(url) {
      this.$router.push({
        path: url
      })
    },
    sendVCode(formName) {
      let self = this;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          self.loading = true;
          // 发送登录请求
          self.$http.post(self.vcodeUrl,  self.form)
            .then(result => {
              if (result.State == 1) { // 登录成功
                self.sendOk = true;
                self.$message.success("验证码发送成功！");
              } else {
                self.$message.error(result.Message);
                self.refreshCaptcha();
              }
              self.loading = false;
            }, () => {
              // 请求失败
              self.$message.error('登录失败，请检查您的网络是否可用。');
              self.loading = false;
            });

          self.sendVCodeTime = 60;

          localStorage.setItem("sendvcodetime", 60);

          let index = setInterval(() => {
            if(self.sendVCodeTime > 0) {
              localStorage.setItem("sendvcodetime", --self.sendVCodeTime);
            }
            else {
              clearInterval(index)
              localStorage.removeItem("sendvcodetime")
            }
          }, 1000);
        } else {
          return false;
        }
      });
    },
    // 表单提交
    submitForm(formName) {
      let self = this;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          // 发送登录请求
          var url = self.loginType == 'first' && self.sendOk ? self.phoneloginUrl : self.loginUrl;
          var pass = self.form.password;
          self.form.password = hex_md5(self.form.password);
          self.$http.post(url,  self.form)
            .then(result => {
              if (result.State == 1) { // 登录成功
                // if(result.Data.Type == "admin") {
                //   try
                //   {
                //     var data=JSON.stringify({
                //       data: result.Data,
                //       token: result.Token
                //     })
                //     document.getElementsByTagName('iframe')[0].contentWindow.postMessage(data,'*');
                //   }
                //   catch(e) {
                //   }
                // }

                localStorage.setItem('ms_webtype', result.Data.Type);
                try {
                  localStorage.setItem('ms_userphone', result.Data.PhoneNumber.substring(0, 3) + '****' + result.Data.PhoneNumber.substring(7));
                } catch (error) {
                }
                localStorage.setItem('ms_customname', result.Data.UserName);
                localStorage.setItem('ms_accountname', result.Data.EmpName);
                localStorage.setItem('ms_customId',result.Data.CustomId);
                self.comeFormWhichCompany();
                self.$router.push('/');

              } else {
                self.$message.error(result.Message);
                self.refreshCaptcha();
                self.form.password = pass;
              }
            }, () => {
              // 请求失败
              self.$message.error('登录失败，请检查您的网络是否可用。');
            });
        } else {
          return false;
        }
      });
    },
    // 验证是不是来自销售公司的程序
    comeFormWhichCompany(){
      let self =this;
      self.$http.post(self.GetProgramQuality, { }).then(result => {
        if (result.State == 1) {
          if(result.Data.Value == 'true'){
            localStorage.setItem('whichProgram', true);
          }else{
            localStorage.setItem('whichProgram', false);
          }
        } else {

        }
      }, () => {
      });
    },
    refreshCaptcha(){
      this.captchaUrlTails = Math.random();
      // this.form.password = '';
      this.form.captcha = '';
    }
  },
  computed:{
    captchaFullUrl() {
      return this.captchaUrl + "?tails=" + this.captchaUrlTails;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Loginnew/Login.js